var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    fill: "#D1E0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 32.2422C18.794 31.435 18 30.0602 18 28.5C18 26.1564 19.7915 24.2313 22.0797 24.0194C22.5478 21.1721 25.0202 19 28 19C30.9798 19 33.4522 21.1721 33.9203 24.0194C36.2085 24.2313 38 26.1564 38 28.5C38 30.0602 37.206 31.435 36 32.2422M24 32L28 28M28 28L32 32M28 28V37",
    stroke: "#004EEB",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 48,
    height: 48,
    rx: 24,
    stroke: "#EFF4FF",
    strokeWidth: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.4870d2fb245d03c3c6d20a5e0a12d601.svg";
export { ForwardRef as ReactComponent };